import i18n from 'i18next';

export default (lng: string) => {
  const lngNormalized = lng.replace('_', '-');
  i18n.changeLanguage(lngNormalized);
  document.documentElement.setAttribute('lang', lngNormalized);
};
